export const progressSystemsData = [
    {
        id: 20,
        systemName: `Программное обеспечение "Железный человек"`,
        applicant: "ВС США",
        owner: "ВС США",
        workType: 5,
        year: 2022,
        startTimeline: '01.03.2022',
        externalTimeline: '22.03.2022',
        internalTimeline: '15.03.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 19,
        systemName: `Геоинформационный портал г. Париж`,
        applicant: "Французская Республика",
        owner: "Французская Республика",
        workType: 4,
        year: 2022,
        startTimeline: '04.03.2022',
        externalTimeline: '25.03.2022',
        internalTimeline: '18.03.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 18,
        systemName: `Геоинформационный портал г.Милан`,
        applicant: "Итальянская Республика",
        owner: "Итальянская Республика",
        workType: 5,
        year: 2022,
        startTimeline: '08.03.2022',
        externalTimeline: '29.03.2022',
        internalTimeline: '22.03.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 17,
        systemName: `Программное обеспечение "Конор Макгрегор"`,
        applicant: "Соединенное королевство Великобритании и Северной Ирландии",
        owner: "Соединенное королевство Великобритании и Северной Ирландии",
        workType: 4,
        year: 2022,
        startTimeline: '10.03.2022',
        externalTimeline: '05.04.2022',
        internalTimeline: '30.03.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 16,
        systemName: "Интернет-портал Systems",
        applicant: "АО ГТС",
        owner: "АО ГТС",
        workType: 5,
        year: 2022,
        startTimeline: '16.03.2022',
        externalTimeline: '12.04.2022',
        internalTimeline: '05.04.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 15,
        systemName: `Программное обеспечение "Железный человек"`,
        applicant: "ВС США",
        owner: "ВС США",
        workType: 5,
        year: 2022,
        startTimeline: '20.03.2022',
        externalTimeline: '17.04.2022',
        internalTimeline: '10.04.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 14,
        systemName: `Геоинформационный портал г. Париж`,
        applicant: "Французская Республика",
        owner: "Французская Республика",
        workType: 4,
        year: 2022,
        startTimeline: '28.03.2022',
        externalTimeline: '24.04.2022',
        internalTimeline: '17.04.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 13,
        systemName: `Геоинформационный портал г.Милан`,
        applicant: "Итальянская Республика",
        owner: "Итальянская Республика",
        workType: 5,
        year: 2022,
        startTimeline: '08.04.2022',
        externalTimeline: '06.05.2022',
        internalTimeline: '30.04.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 12,
        systemName: `Программное обеспечение "Конор Макгрегор"`,
        applicant: "Соединенное королевство Великобритании и Северной Ирландии",
        owner: "Соединенное королевство Великобритании и Северной Ирландии",
        workType: 4,
        year: 2022,
        startTimeline: '11.04.2022',
        externalTimeline: '13.05.2022',
        internalTimeline: '08.05.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
    {
        id: 11,
        systemName: "Интернет-портал Systems",
        applicant: "АО ГТС",
        owner: "АО ГТС",
        workType: 5,
        year: 2022,
        startTimeline: '19.04.2022',
        externalTimeline: '23.05.2022',
        internalTimeline: '18.03.2022',
        status: "В работе",
        statusIndicator: "processing"
    },
]